/**
 * Created by Dhanya Akhil on 3/1/2017.
 */
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { SendWelcomeMailService } from '../services/send-welcomemail.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-userlock',
  templateUrl: './send-welcomemail.component.html',
  styleUrls: ['./send-welcomemail.component.css']
})
export class SendWelcomeMailComponent implements OnInit {
  success;
  error;
  data;

  errorMessage: string = 'Server Error';
  language: string;
  public lang;
  public browserLang;
  doNotMatch = false;
  message;
  public users;
  public totalItems;
  public currentPage = 1;
  public pageNumber;
  public pageSize;
  public unlockId;
  public noData: boolean = false;
  public numPages: number = 0;
  errorERRWE000001: any = false;
  errorERRWE000002;
  errorERRWE000003;

  public userSearchForm = new FormGroup({
    'employeeId': new FormControl('', Validators.required),
    'certificateNumber': new FormControl('', Validators.required)
  });
  public employeeId: AbstractControl = this.userSearchForm.get('employeeId');
  public certificateNumber: AbstractControl = this.userSearchForm.get('certificateNumber');

  constructor(public welcomeMailServiice: SendWelcomeMailService, private translate: TranslateService) {
    this.lang = translate.currentLang;

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.browserLang = event.lang
      this.lang = this.browserLang;
    });
  }


  ngOnInit() {
    this.employeeId.patchValue('');
    this.certificateNumber.patchValue('');
    this.pageNumber = 1;
    this.pageSize = 10;
    this.getuser();
  }

  public resetForgotPasswordErrors() {
    this.error = false;
    this.errorERRWE000001 = false;
    this.errorERRWE000002 = false;
    this.errorERRWE000003 = false;
  }

  public getuser() {
    this.welcomeMailServiice.getUser(this.employeeId.value, this.certificateNumber.value, this.pageNumber, this.pageSize)
      .subscribe(
        (response) => {
          this.error = false;
          this.noData = false;
          this.users = response['content'];
          if (response['content'].length == 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
          this.totalItems = response['totalElements'];
        },
        (error) => {
          this.error = true;
        }
      );
  }

  sendForgotPassword(unlockId) {
    this.error = false;
    this.success = false;
    this.welcomeMailServiice.sendWelcomeMail(unlockId).subscribe(
      data => {
        this.data = data;
        if (this.data.status == 200) {
          this.resetForgotPasswordErrors();
          this.success = true;
          this.message = this.data.message;
          this.pageNumber = 1;
          this.pageSize = 10;
          this.getuser();
        } else {
          this.success = null;
          this.resetForgotPasswordErrors();
          if (this.data.status !== null || this.data.status !== undefined) {
            this['error' + this.data.status] = true;
            this.message = this.data.message;
          } else {
            this.error = 'ERROR';
            this.message = this.data.message;
          }
        }
      },
      error => this.errorMessage = <any>error);

  }

  public pageChanged(event: any): void {
    this.pageNumber = event.page;
    this.pageSize = event.itemsPerPage;
    this.getuser();
  }

  public clearSearchData() {
    if ((this.employeeId.value).length == 0 || (this.certificateNumber.value).length == 0) {
      this.employeeId.patchValue('');
      this.certificateNumber.patchValue('');
      this.pageNumber = 1;
      this.pageSize = 10;
      this.getuser();
    }
  }

}
